import Swiper from 'swiper';
import {Thumbs, Navigation, Pagination, Controller, EffectFade, Autoplay} from 'swiper/modules';

export function handleSliders():void {
	const headings = document.querySelector<HTMLElement>(
		'.advisory__info .info__slider'
	)
	const thumbnails = document.querySelector<HTMLElement>(
		'.thumbnail__gallery'
	)
	const quotes = document.querySelector<HTMLElement>('.quote__slider .swiper')
	const images = document.querySelector<HTMLElement>('.image__slider .swiper')

	const baseSettings = {
		slidesPerView: 1,
		spaceBetween: 10,
		effect: 'fade',
		fadeEffect: {
			crossFade: true,
		}
	}

	// @ts-ignore
	const headingsSlider = new Swiper(headings, {
		...baseSettings,
		modules: [Controller, EffectFade],
	})

	// @ts-ignore
	const quoteSlider = new Swiper(quotes, {
		modules: [Navigation, Pagination, Controller, EffectFade, Autoplay],
		...baseSettings,
		navigation: {
			prevEl: '.quote__slider .swiper-button-prev',
			nextEl: '.quote__slider .swiper-button-next',
		},
		pagination: {
			clickable: true,
			el: '.quote__slider .swiper-pagination',
		},
		autoplay: {
			delay: 5000,
			disableOnInteraction: false,
		}
	})

	// @ts-ignore
	const thumbnailSlider = new Swiper(thumbnails, {
		slidesPerView: 4,
		freeMode: true,
		watchSlidesProgress: true,
	})

	// @ts-ignore
	const imagesSlider = new Swiper(images, {
		modules: [Thumbs, Controller],
		thumbs: {
			swiper: thumbnailSlider,
		},
	})

	imagesSlider.controller.control = [quoteSlider, headingsSlider]
	quoteSlider.controller.control = [imagesSlider, headingsSlider]

	const section = document.querySelector('.section--advisories')
	if (section) {
		section.addEventListener('mouseenter', () => quoteSlider.autoplay.pause())
		section.addEventListener('mouseleave', () => quoteSlider.autoplay.resume())
		section.addEventListener('focusin', () => quoteSlider.autoplay.pause())
		section.addEventListener('focusout', () => quoteSlider.autoplay.resume())
	}
}